import { AxiosError } from "axios";

import { ErrorResponse } from "@/v1/types/global";
import { IS_DEVELOPMENT } from "@/v1/utils/constants";

import { SERVER_ERROR_STATUS } from "./constants";

/**
 * The error's message, or `null`. Server errors keep it hidden outside
 * development, like the app's error toasts.
 */
export const getErrorResponseMessage = (error: unknown): string | null => {
  const response = (error as AxiosError<ErrorResponse> | undefined)?.response;
  const isServerError = (response?.status ?? 0) >= SERVER_ERROR_STATUS;
  if (isServerError && !IS_DEVELOPMENT) return null;
  return response?.data?.errors?.[0]?.message || null;
};

/** The HTTP status, or `null` without a response. */
export const getErrorResponseStatus = (error: unknown): number | null =>
  (error as AxiosError | undefined)?.response?.status ?? null;
